<template>
  <v-container class="pb-9" fluid>
    <v-row>
      <v-col
        class="
          align-center
          d-flex
          flex-wrap
          font-size-lg-res font-weight-semibold
        "
        :class="{ 'justify-center': textCentered }"
      >
        <v-icon v-if="icon" color="primary" class="font-weight-thin">{{
          icon
        }}</v-icon>
        <Icon
            v-if="src"
            :name="getSrc()"
            :color="$vuetify.theme.themes.light.primary"
            :title="text"
            :style="{height:'32px', width: '32px'}"
        ></Icon>
        <h3 class="primary-color font-size-lg text-no-wrap e2e-title-department ml-1">
          {{ text }}
        </h3>
        <h4 v-if="sub" class="d-flex">
          <span class="ml-2 mr-1">/</span>
          {{ sub }}
        </h4>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapState } from "vuex";
import Icon from '@/components/UI/Icon.vue'

export default {
  name: "Title",
  computed:{
     ...mapState({
      storeInfo: (state) => state.store.info,
    }),
  },
  methods: {
    getSrc(){
      if(this.src == 'menu' && this.storeInfo.menu_as_featured){
        return 'featured';
      }
      return this.src;

    },
  },
  components: {Icon},
  props: {
    icon: String,
    src: String,
    sub: String,
    text: String,
    textCentered: Boolean,
  },
};
</script>
